import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

import Highlighter from '../../../components/highlighter'

const SuggestionsListItem = props => {
  const {
    styles,
    focusedIndex,
    inputValue,
    onMenuClick,
    handleMenuMouseEnter,
    handleMenuMouseLeave,
    index,
    suggestion,
    showSeparator
  } = props

  return (
    <li
      className={classnames(styles.listItem, {
        [styles.focusedListItem]: focusedIndex === index,
        [styles.separator]: showSeparator
      })}
      onMouseDown={event => onMenuClick(suggestion, event)}
      onMouseEnter={() => handleMenuMouseEnter(index)}
      onMouseLeave={() => handleMenuMouseLeave(index)}
    >
      <a
        className="fds-c-text-link -color-dark -decoration-none"
        href={suggestion.link}
      >
        <span className={classnames(styles.suggestionText, 'h-text-truncate')}>
          <Highlighter bold keywords={inputValue.trim().split(' ')}>
            {suggestion.text}
          </Highlighter>
          {suggestion.category && (
            <span
              className={classnames(styles.categoryText, 'h-text-truncate')}
            >
              in {suggestion.category}
            </span>
          )}
        </span>
      </a>
    </li>
  )
}

SuggestionsListItem.propTypes = {
  suggestion: PropTypes.object,
  styles: PropTypes.object,
  focusedIndex: PropTypes.number,
  inputValue: PropTypes.string,
  onMenuClick: PropTypes.func,
  handleMenuMouseEnter: PropTypes.func,
  handleMenuMouseLeave: PropTypes.func,
  index: PropTypes.number,
  showSeparator: PropTypes.bool
}

export default SuggestionsListItem
